module.exports = __webpack_public_path__ + "img/ico_wifi.848bb45d.png";